import dispatcher from '../dispatcher/dispatcher.js';

export function createImage(imageObj){
    dispatcher.dispatch({
        type: 'CREATE_IMAGE',
        object: imageObj
    });
}


// WEBPACK FOOTER //
// ./src/action/imageAction.js